import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { TextBold, TextMedium } from 'UiKit/typography';
import Drawer from 'UiKit/drawer';
import { CloseIcon } from 'Asset/icon';
import { Iteration } from 'Component/others';

import styles from './styles.module.css';

const ContentDrawerInfo = ({ isOpen, onClose }) => {
  const { t } = useTranslation('host-content');

  const paragraphs = [t('drawer_info.paragraph_1'), t('drawer_info.paragraph_2'), t('drawer_info.paragraph_3')];

  return (
    <Drawer className={styles['drawer__container']} height="40vh" isOpen={isOpen} onClose={onClose}>
      <Box className={styles['section__head']}>
        <TextBold className={styles['section__title']}>{t('drawer_info.title')}</TextBold>
        <CloseIcon size="18px" onClick={onClose} />
      </Box>

      <Box className={styles['section__content']}>
        <Box className={styles['content__item']}>
          <Iteration
            items={paragraphs}
            render={(paragraph, index) => (
              <TextMedium
                className={styles['paragraph__text']}
                color={index === 1 ? 'var(--color-neutral70)' : undefined}
                dangerouslySetInnerHTML={{ __html: paragraph }}
              />
            )}
          />
        </Box>
      </Box>
    </Drawer>
  );
};

export default ContentDrawerInfo;
